export enum BON_COMMANDES_ROUTES {
  GET_ALL = "/bon",
  GET = "/bon/",
  CREATE = "/bon",
  UPDATE = "/bon/",
  REMOVE = "/bon/",
  DOWNLOAD = "/bon/",
  GET_STATISTIC = "/bon/statistics",
  GET_ON_HOLD = "/bon/onhold",
  GET_LATE = "/bon/late",
}
